import * as React from 'react';
import theme from '../theme/theme';
import { Avatar, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
         useMediaQuery, styled } from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.grey[100],
      padding: '15px 2px 12px 2px',
      //borderRadius: '3px',
      //color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
      //backgroundColor: '#ff0000',
      padding: '10px 2px 10px 2px',
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: theme.palette.primary.contrastText,
    //'&:nth-of-type(odd)': {
      //backgroundColor: theme.palette.action.hover,
    //},
    // hide last border
    //'&:last-child td, &:last-child th': {
      //border: 0,
    //},
}));

const TableGroup = (props) => {

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell align="left" style={{paddingLeft: '10px', width: '150px', borderTopLeftRadius: '10px'}}>Team</StyledTableCell>
            <StyledTableCell align="center" style={{width: '30px'}}>Pld</StyledTableCell>
            <StyledTableCell align="center" style={{width: '50px', paddingLeft: '20px'}}>W</StyledTableCell>
            <StyledTableCell align="center" style={{width: '30px'}}>D</StyledTableCell>
            <StyledTableCell align="center" style={{width: '50px', paddingRight: '20px'}}>L</StyledTableCell>
            <StyledTableCell align="center" style={isSmUp ? { width: '100px' } : {width: '100px', display: 'none'}} colSpan={3}>Goals</StyledTableCell>
            <StyledTableCell align="center" style={{width: '50px', padding: '10px 10px 10px 20px', borderTopRightRadius: '10px'}}>Pts</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.group.map((gt, i) => (
            <StyledTableRow key={i}>
              <StyledTableCell component="th" scope="row" align="left" style={{paddingLeft: '10px'}}>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Avatar src={gt.teamFlag} sx={{ width: '20px', height: '20px', marginRight: '10px' }} />
                    </Grid>
                    <Grid item>
                        <span className={[0,1].includes(i) ? "boldest" : "medium"}>{gt.teamName}</span>
                    </Grid>
                </Grid>
              </StyledTableCell>
              <StyledTableCell align="center">{gt.pld}</StyledTableCell>
              <StyledTableCell align="center" style={{paddingLeft: '20px'}}>{gt.win}</StyledTableCell>
              <StyledTableCell align="center">{gt.drawn}</StyledTableCell>
              <StyledTableCell align="center" style={{paddingRight: '20px'}}>{gt.lost}</StyledTableCell>
              <StyledTableCell align="center" style={isSmUp ? { padding: '10px 2px 10px 2px' } : {padding: '10px 2px 10px 2px', display: 'none'}}>{gt.gf}</StyledTableCell>
              <StyledTableCell align="center" style={isSmUp ? { padding: '10px 2px 10px 2px' } : {padding: '10px 2px 10px 2px', display: 'none'}}>{gt.ga}</StyledTableCell>
              <StyledTableCell align="center" style={isSmUp ? { padding: '10px 2px 10px 2px' } : {padding: '10px 2px 10px 2px', display: 'none'}}>{gt.gd}</StyledTableCell>
              <StyledTableCell align="center" style={{padding: '10px 10px 10px 20px'}}><span className="medium">{gt.pts}</span></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>  
    );
};
export default TableGroup;